import React from 'react';

import { Drawer as DrawerShared } from '@bcp-channels-sharedcomponents-reactjs/feedback';
import { Box, PDFViewer } from '@bcp-nextgen-dx-component-factory/design-system';
import { rem } from '@helpers';

import { usePdfViewerDrawerHelper } from './pdfViewerDrawer.helper';

// to fix not exists children prop in react-18
const Drawer = DrawerShared as any;

export interface PdfViewerDrawerProps {
	title: string;
	subtitle: string;
	base64: string;
	drawerUniqueName: string;
	handleOnClickAcceptTerms: () => void;
	wasAccepted?: boolean;
}

export const PdfViewerDrawer: React.FC<PdfViewerDrawerProps> = ({
	base64,
	drawerUniqueName,
	handleOnClickAcceptTerms,
	title,
	subtitle,
	wasAccepted,
}) => {
	const { resources, drawerTopDistance, ref, pdfViewerHeight, onScrolled, hidePdfDrawer, scrolled } =
		usePdfViewerDrawerHelper({
			drawerUniqueName,
		});

	return (
		<>
			<Drawer
				name={drawerUniqueName}
				customDragHandle={<span></span>}
				childrenContentStyle={{ paddingLeft: 0 }}
				minTopDistance={drawerTopDistance}
			>
				<Box
					styles={{
						marginRight: rem(-24),
						height: '100%',
						overflow: 'hidden',
						borderRadius: rem(24, 24, 0, 0),
					}}
				>
					<PDFViewer
						ref={ref}
						height={pdfViewerHeight}
						download
						pdfProps={{
							name: title,
							resource: base64,
							resourceType: 'base64',
							allowTextSelection: true,
							onScroll: onScrolled,
						}}
						header={{
							title: title,
							text: subtitle,
							onBackArrowPress: hidePdfDrawer,
						}}
						footer={
							!wasAccepted
								? {
										text: resources.confirmReadAndAccepted,
										buttonText: resources.confirmAndAccepted,
										required: true,
										onComplete: handleOnClickAcceptTerms,
								  }
								: undefined
						}
						walkthroughOverlay={
							!wasAccepted && !scrolled
								? {
										zIndex: 3,
										text: resources.scrollToReadAndAccept,
										button: {
											text: resources.gotIt,
										},
								  }
								: undefined
						}
					/>
				</Box>
			</Drawer>
		</>
	);
};
